// Azioni multiple sulla selezione "tutti" di Crud.
// Due famiglie: i dialog che il backend sa risolvere da solo sul filtro della tabella
// (select_all + filtri, nessun limite) e tutte le altre, che ricevono id o righe:
// per quelle Crud carica le righe della lista, fino al limite dell'azione.

// Dialog con select_all lato backend (Model::queryFilters sui filtri della richiesta)
export const SERVER_SELECT_ALL_COMPONENTS = [
    'convert-document-dialog',
    'generate-ddt',
    'callqueue-dialog',
    'maillist-dialog',
    'whats-app-list-dialog',
]

// Limiti misurati in locale (PHP e nginx a 600 s come in yellodock), tenendo ogni azione sotto i ~2 minuti.
// Default: elimina 1000 DDT 32 s, modifica multipla 1000 righe 6-11 s, barcode 1000 prodotti 12 s
export const DEFAULT_SELECTION_LIMIT = 1000

const COMPONENT_LIMITS = {
    // convert-docx valida selected max:200
    'parse-doc-dialog': 200,
    // GET con ids[] in query string: oltre qualche centinaio di id l'URL supera i buffer di nginx
    'edocument-sender-button': 400,
    // un PDF per documento dentro la richiesta, ~1 s l'uno
    'send-multiple-mails': 100,
    // un ticket con PDF per riga dentro la richiesta, ~1 s l'uno
    'generate-trouble-dialog': 100,
}

// ZIP dei PDF: un solo job che crea i PDF mancanti (~1 s l'uno); oltre 300 s (retry_after
// della coda database) il job verrebbe ripreso da un altro worker
const PDF_ZIP_LIMIT = 300

export function usesServerSelectAll(button) {
    return button.type === 'component' && SERVER_SELECT_ALL_COMPONENTS.includes(button.component)
}

/**
 * Input:  buttonDef di ButtonsGenerator, serverSelectAll: se il dialog risolverà "tutti" sul backend
 * Output: numero massimo di elementi su cui l'azione può girare in modalità "tutti", null = nessun limite
 */
export function selectionLimit(button, serverSelectAll = usesServerSelectAll(button)) {
    if (button.type === 'csv' || serverSelectAll) {
        return null
    }
    if (button.type === 'component' && COMPONENT_LIMITS[button.component]) {
        return COMPONENT_LIMITS[button.component]
    }
    if (button.type === 'zip' && !/xml/.test(button.url || '')) {
        return PDF_ZIP_LIMIT
    }
    return DEFAULT_SELECTION_LIMIT
}

/**
 * Input:  axios, richiesta lista {uri, payload} della tabella, opzioni {perPage, cancelToken, onProgress(done, total)}
 * Fa:     scorre la lista a pagine grandi con la stessa richiesta della tabella
 * Output: Promise<Array> righe, senza doppioni: un documento creato mentre si carica fa scivolare le
 *         pagine successive e l'ultima riga di una pagina ricompare nella seguente (mail inviate due volte)
 */
export async function loadListRows(axios, { uri, payload }, { perPage = 1000, cancelToken, onProgress } = {}) {
    const meili = uri === 'meilisearch/search'
    const size = meili ? Math.min(perPage, 500) : perPage
    const rows = []
    const seen = new Set()
    let page = 1
    let total = 0
    let pageRows
    do {
        const body = { ...payload, page, per_page: size }
        if (!meili) {
            body.with_totals = false
        }
        const response = await axios.post(uri, body, { cancelToken })
        pageRows = meili ? response.data.data : response.data.data.data
        total = meili ? response.data.pagination.total : response.data.data.total
        pageRows.forEach(row => {
            if (!seen.has(row.id)) {
                seen.add(row.id)
                rows.push(row)
            }
        })
        if (onProgress) {
            onProgress(rows.length, total)
        }
        page++
    } while (pageRows.length && (page - 1) * size < total)
    return rows
}
